import React from 'react'

import noop from 'lodash/noop'

import cn from '../../../../commons/src/libs/class-names'

import closeSmallIcon from '../../../../commons/src/assets/icons/close-small.svg'

import Icon from '../../../../commons/src/components/icon'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  onClick?: React.MouseEventHandler
  locked?: boolean
  unlockButtonIconTitle?: string
  disabled?: boolean
}

const MixedValueInputWrapper = ({
  classNames,
  children,
  unlockButtonIconTitle,
  locked = false,
  disabled = false,
  onClick = noop,
}: Props) => (
  <div className={cn('MixedValueInputWrapper', {locked, disabled}, classNames)}>
    <div className="MixedValueInputWrapper__input">{children}</div>
    <button
      disabled={disabled}
      className="MixedValueInputWrapper__button"
      type="button"
      onClick={onClick}
    >
      <Icon source={closeSmallIcon} title={unlockButtonIconTitle} block />
    </button>
  </div>
)

export default MixedValueInputWrapper
